<div class="payment-info">
    @if(showHeader) {
        <div class="header">{{ 'initLogin.onetimePaymentHeader' | translate }}</div>
    }
    <div class="payment-layout">
        <div class="qr-container">
            @if(depositInfo) {
                <liberro-qr-payment
                [accountNumber]="depositInfo.accountNumber"
                [variableSymbol]="depositInfo.variableSymbol"
                [specificSymbol]="specificSymbol"
                [bankCode]="depositInfo.bankCode"
                [currency]="depositInfo.currency"
                ></liberro-qr-payment>
            }
        </div>
        <div class="payment-values">
            @if(depositInfo) {
                <liberro-payment-row [translateKey]="'accountNumber'" [value]="depositInfo.accountNumber + '/' + depositInfo.bankCode"></liberro-payment-row>
                <liberro-payment-row [translateKey]="'variableSymbol'" [value]="depositInfo.variableSymbol"></liberro-payment-row>
                <liberro-payment-row [translateKey]="'specificSymbol'" [value]="specificSymbol"></liberro-payment-row>
                @if (onetimeDepositAmount > 0) {
                    <liberro-payment-row [translateKey]="'amount'" [value]="onetimeDepositAmount | price:depositInfo.currency"></liberro-payment-row>
                }
            }
        </div>
    </div>
</div>